import { render, staticRenderFns } from "./BillingPackages.vue?vue&type=template&id=d23b971e&"
import script from "./BillingPackages.vue?vue&type=script&lang=ts&"
export * from "./BillingPackages.vue?vue&type=script&lang=ts&"
import style0 from "./BillingPackages.vue?vue&type=style&index=0&id=d23b971e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports